module.exports = __webpack_public_path__ + "649d2e5756a4f7f9717ed227bfbe58c7.svg";